import React, { SyntheticEvent, useRef, useState } from 'react'

import { Box, FontFamily, JustifyContent, Text } from '@gousto-internal/citrus-react'
import PropTypes from 'prop-types'

import ModalComponent, { ModalContent, ModalTitle } from 'components/ModalComponent'

import { RecipeAlternativeOptions } from '../../RecipeAlternativeOptions'
import { useClickOutside } from './useClickOutside'
import { useTracking } from './useTracking'

// eslint-disable-next-line @typescript-eslint/no-var-requires
const css = require('./SwapAlternativeOptions.css')

export const SwapAlternativeOptionsMobile: React.FC<{
  recipeId: string
  originalId: string
  categoryId: string
}> = ({ recipeId, originalId, categoryId }) => {
  const [showModal, setShowModal] = useState(false)

  const collectionId = categoryId
  const { trackRecipeAlternativeOptionsMenuOpen, trackRecipeAlternativeOptionsMenuSwapRecipes } =
    useTracking()

  const selectRef = useRef(null)
  useClickOutside(selectRef, () => setShowModal(false), [showModal])

  const onCloseModal = (e: SyntheticEvent) => {
    e.stopPropagation()
    setShowModal(false)
  }
  const onClickButton = (
    event: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>,
  ) => {
    event.stopPropagation()
    setShowModal(!showModal)
    if (!showModal) {
      trackRecipeAlternativeOptionsMenuOpen({ recipeId, collectionId })
    }
  }

  return (
    <Box display="flex" justifyContent={JustifyContent.FlexEnd} style={{ marginLeft: '1rem' }}>
      <Box
        data-testid="SwapAlternativeOptionsMobileButton"
        className={css.button}
        onClick={onClickButton}
        onKeyDown={onClickButton}
        role="button"
        tabIndex={-1}
      >
        <Text fontFamily={FontFamily.Bold}>Options</Text>
      </Box>
      {showModal && (
        <ModalComponent
          visible={showModal}
          styleName={css.variantRecipeListModal}
          from="bottom"
          onClose={onCloseModal}
          overlayContentClassName={css.variantRecipeListOverlayContent}
        >
          <ModalTitle className={css.variantRecipeListModalTitleWrapper}>
            <h1 className={css.variantRecipeListModalTitle}>Options available</h1>
            <button
              type="button"
              className={css.variantRecipeListModalCloseX}
              onClick={onCloseModal}
            />
          </ModalTitle>

          <Box ref={selectRef}>
            <ModalContent className={css.variantRecipeListModalContent}>
              <RecipeAlternativeOptions
                recipeId={recipeId}
                originalId={originalId}
                categoryId={categoryId}
                closeOnSelection
                onChangeCheckedRecipe={({ previousRecipeId, nextRecipeId }) =>
                  trackRecipeAlternativeOptionsMenuSwapRecipes({
                    collectionId,
                    previousRecipeId,
                    nextRecipeId,
                  })
                }
              />
            </ModalContent>
          </Box>
        </ModalComponent>
      )}
    </Box>
  )
}

SwapAlternativeOptionsMobile.propTypes = {
  recipeId: PropTypes.string.isRequired,
  originalId: PropTypes.string.isRequired,
  categoryId: PropTypes.string.isRequired,
}
